export default __webpack_public_path__ + "img/d1081e33a0e76e6201accc57c16e3f5c.png";